// extracted by mini-css-extract-plugin
export default {"container":"NexsetDetailDrawer_container__1HLZK"};